import { Button } from "components/atoms";
import { PublicPage } from "components/templates";
import { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { PiConfetti, PiFingerprintSimple } from "react-icons/pi";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useConfirmEmailWithoutPassword } from "services/auth/confirmEmail";
import { useGetClientModuleConfiguration } from "services/configuration";
import { onErrorShowAllErrorsToast } from "utils/service/errorHandler";

const ConfirmEmail = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const confirmEmail = useConfirmEmailWithoutPassword();

  const email = params.get("email") ?? "";
  const token = params.get("token")?.replaceAll(" ", "+") ?? "";

  const goToLogin = () => navigate(`/login?email=${email}`);

  const configurationModule = useGetClientModuleConfiguration();
  console.log(
    "Configuration Module Data:",
    configurationModule.data?.clientName,
  );
  console.log("test 2");
  const onConfirmEmail = async () => {
    await confirmEmail.mutateAsync(
      { email, token },
      {
        onError: (error) => onErrorShowAllErrorsToast(error),
      },
    );
  };

  useEffect(() => {
    onConfirmEmail();
  }, []);

  return (
    <PublicPage
      header={
        <div className="flex gap-4  items-center">
          <PiConfetti size={50} />
          <p className="text-lg font-semibold">
            {t("confirm-email.creative.header")}
          </p>
        </div>
      }
    >
      <p>
        <Trans
          i18nKey="confirm-email.creative.welcome"
          values={{
            email: email,
          }}
          components={{ strong: <strong /> }}
        />
      </p>
      <p className="text-center">
        <Trans
          i18nKey="confirm-email.creative.message"
          values={{
            company: configurationModule.data?.clientName,
          }}
        />
      </p>
      <div />
      <div />
      <Button isLoading={confirmEmail.isPending} fullWidth onClick={goToLogin}>
        <Button.Text text={t("confirm-email.button")} />
        <Button.Icon icon={<PiFingerprintSimple />} />
      </Button>
    </PublicPage>
  );
};

export default ConfirmEmail;
